import { colorScales } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { iconStyle, type LiveStatusIconSize } from "../LiveAppIcons";
export function ProgressingIcon(size: LiveStatusIconSize, ariaLabel?: string) {
    return (<span role="img" className={iconStyle(size)} style={{ background: colorScales.blue[500] }} aria-label={ariaLabel}>
            <em className="fa-solid fa-circle-notch fa-spin"/>
        </span>);
}
